<form class="layout-padding flex flex-col gap-4" [formGroup]="form">
  <div class="flex items-center gap-3">
    <mat-form-field class="flex-1">
      <mat-label>Name</mat-label>
      <input type="text" matInput formControlName="name" [required]="true" />
    </mat-form-field>
    <mat-form-field class="flex-1">
      <mat-label>Keyword</mat-label>
      <input type="text" matInput formControlName="keyword" />
      <mat-hint>
        Set a unique keyword to make finding this multi-treatment easier
      </mat-hint>
    </mat-form-field>
  </div>
  <pt-buttons-container>
    <button mat-stroked-button color="warn" (click)="delete()">Delete</button>
    <button mat-flat-button color="primary" (click)="save()">Save</button>
  </pt-buttons-container>
</form>
